import { trigger, state, animate, animateChild, group, style, transition, query } from '@angular/animations';

export function routerTransition() {
    return slide();
}

export function globalRouterTransition() {
    return fade();
}


export function fade() {
    return trigger('globalRouterTransition', [
        transition('* => *', [
            // Initial state of new route
            query(':enter',
                style({ opacity: 0 }),
                { optional: true }
            ),

            group([
                query(':leave',
                    [
                        style({ opacity: 1 }),
                        animate('500ms ease', style({ opacity: 0 }))
                    ]
                    ,
                    { optional: true }
                ),

                query(':enter',
                    [
                        style({ opacity: 0 }),
                        animate('500ms ease', style({ opacity: 1 })),
                        animateChild()
                    ],
                    { optional: true }
                )
            ])
        ])
    ]);
}

export function fadeTransition() {
    return trigger('fadeTransition', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('5s', style({ opacity: 1 })),
        ]),
        transition(':leave', [
          animate('1s', style({ opacity: 0 }))
        ])
      ]);
}

function test() {
    return trigger('routerTransition', [
        transition('* <=> *', [
            // Initial state of new route
            query(':enter',
                style({
                    position: 'fixed',
                    width: '100%',
                    transform: 'translateX(-100%)'
                }),
                { optional: true }),

            // move page off screen right on leave
            query(':leave',
                animate('500ms ease',
                    style({
                        position: 'fixed',
                        width: '100%',
                        transform: 'translateX(100%)'
                    })
                ),
                { optional: true }),

            // move page in screen from left to right
            query(':enter',
                animate('500ms ease',
                    style({
                        opacity: 1,
                        transform: 'translateX(0%)'
                    })
                ),
                { optional: true }),
        ])
    ]);
}


export function slide() {
    return trigger('routerTransition', [
        transition('* <=> *', [
            // Initial state of new route
            query(':enter',
                style({
                    position: 'fixed',
                    width: '{{ inWidth }}',
                    height: '{{ inHeight }}',
                    transform: 'translateX(-100%)'
                }),
                { optional: true }),

            // move page off screen right on leave
            query(':leave',
                animate('500ms ease',
                    style({
                        position: 'fixed',
                        width: '{{ outWidth }}',
                        transform: 'translateX(100%)'
                    })
                ),
                { optional: true }),

            // move page in screen from left to right
            query(':enter',
                animate('500ms ease',
                    style({
                        opacity: 1,
                        transform: 'translateX(0%)'
                    })
                ),
                { optional: true }),
        ])
    ]);
}

function slideToRight() {
    return trigger('routerTransition', [
        state('void', style({ position: 'fixed', width: '100%' })),
        state('*', style({ position: 'fixed', width: '100%' })),
        transition(':enter', [
            style({ transform: 'translateX(-100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
        ])
    ]);
}

function slideToLeft() {
    return trigger('routerTransition', [
        state('void', style({ position: 'fixed', width: '100%' })),
        state('*', style({ position: 'fixed', width: '100%' })),
        transition(':enter', [
            style({ transform: 'translateX(100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
        ])
    ]);
}

function slideToBottom() {
    return trigger('routerTransition', [
        state('void', style({ position: 'fixed', width: '100%', height: '100%' })),
        state('*', style({ position: 'fixed', width: '100%', height: '100%' })),
        transition(':enter', [
            style({ transform: 'translateY(-100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateY(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(100%)' }))
        ])
    ]);
}

function slideToTop() {
    return trigger('routerTransition', [
        state('void', style({ position: 'fixed', width: '100%', height: '100%' })),
        state('*', style({ position: 'fixed', width: '100%', height: '100%' })),
        transition(':enter', [
            style({ transform: 'translateY(100%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(0%)' }))
        ]),
        transition(':leave', [
            style({ transform: 'translateY(0%)' }),
            animate('0.5s ease-in-out', style({ transform: 'translateY(-100%)' }))
        ])
    ]);
}
